// src/pages/Claims.js
import React, { useState } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  Divider,
} from "@mui/material";
import PatientHeader from "../../components/PatientHeader/PatientHeader";

// Example data for the patient profile
const exampleProfile = {
  dob: "01/01/1980",
  lastPcpVisit: "06/01/2024",
  opportunityScore: "Score",
  erVisits: 0,
  admits: 0,
  age: 44,
};

// Column definitions for the Claims table
const columns = [
  "Service Date",
  "Claim",
  "Claim Line #",
  "Provider Name",
  "Provider Type",
  "Diag Code1",
  "Diag Code2",
  "Diag Code3",
  "Diag Code4",
  "Diag Code5",
  "Diag Code6",
  "Diag Code7",
  "Diag Code8",
  "Diag Code9",
  "Procedure Code",
  "Amount",
];

// Sample rows (empty for now)
const initialClaims = [];

const Claims = () => {
  const [patientProfile] = useState(exampleProfile);
  const [claimsData] = useState(initialClaims);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [page, setPage] = useState(0);

  // Handle page change in the table pagination
  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <div style={{ margin: "50px auto", width: "80%" }}>
      <Paper elevation={3} style={{ padding: "20px" }}>
        {/* Reuse the Patient Header */}
        <PatientHeader
          dob={patientProfile.dob}
          lastPcpVisit={patientProfile.lastPcpVisit}
          opportunityScore={patientProfile.opportunityScore}
          erVisits={patientProfile.erVisits}
          admits={patientProfile.admits}
          age={patientProfile.age}
        />
        <Divider />

        {/* Claims Section */}
        <Box marginTop={4}>
          <Typography variant="h5" align="center">
            Claims in the past 12 months
          </Typography>

          {/* Table with Claims Data */}
          <TableContainer component={Paper} style={{ marginTop: "20px" }}>
            <Table>
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell key={column}>{column}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {claimsData.length > 0 ? (
                  claimsData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow key={index}>
                        {columns.map((column) => (
                          <TableCell key={column}>
                            {row[column.toLowerCase().replace(/\s/g, "")]}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      No data available in table
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50, 100]}
              component="div"
              count={claimsData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        </Box>
      </Paper>
    </div>
  );
};

export default Claims;
